import React from "react";
import PropTypes from "prop-types";
import styles from "./FilterDropdown.module.css";

const FilterDropdown = ({
  selectedFilter,
  onFilterChange,
  monthOptions,
  isVisible = true,
  initialLoad,
  isTabClicked,
}) => {
  if (!isVisible) return null;

  // Determine the dropdown value - if it's a fixed option, show 'All', otherwise show the selected value
  const getDropdownValue = () => {
    if (initialLoad === false) {
      return "12";
    }
    const fixedOptions = ["12", "24", "36", "48", "60"];
    if (fixedOptions.includes(selectedFilter) && isTabClicked === true) {
      return ""; // Show "All" when a fixed option is selected
    }
    return selectedFilter;
  };

  const handleViewAll = () => {
    onFilterChange("monthly"); // Reset to show all monthly options
  };

  return (
    <div className={styles.filterSection}>
      <span></span>
      <div className={styles.filterDropdownContainer}>
        <label htmlFor="contractFilter" className={styles.filterLabel}>
          Filter by contract length
        </label>
        <div className={styles.filterWrapper}>
          <select
            id="contractFilter"
            name="filter1"
            className={styles.filterDropdown}
            value={getDropdownValue()}
            onChange={(e) => onFilterChange(e.target.value)}
            aria-label="Select contract length filter"
          >
            {monthOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <button
            type="button"
            className={styles.viewAllButton}
            onClick={handleViewAll}
            aria-label="View all contract lengths"
          >
            View all
          </button>
        </div>
      </div>
      <span></span>
    </div>
  );
};

FilterDropdown.propTypes = {
  selectedFilter: PropTypes.string.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  monthOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  isVisible: PropTypes.bool,
  initialLoad: PropTypes.bool.isRequired,
  isTabClicked: PropTypes.bool.isRequired,
};

export default FilterDropdown;
